import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import CruisePriceRoomTypeInfo from './CruisePriceRoomTypeInfo'
import { mediaQueryUp } from 'components/utils/breakpoint'

const FooterWrapper = styled(Pane)`
  bottom: 0;
  box-shadow: ${({ theme }) => theme.shadow.top.small};
  display: flex;
  flex-direction: column;
  padding: ${rem(20)} ${rem(16)};
  position: fixed;
  width: 100vw;
  z-index: 100;
  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  onView: (ref: string) => void;
  priceFrom: App.CruisePriceDetails;
  hasValidDepartures?: boolean;
}

function CruiseStickyFooter(props: Props) {
  const { onView, priceFrom, hasValidDepartures } = props

  return (
    <FooterWrapper data-testid="tour-v2-sticky-footer">
      <CruisePriceRoomTypeInfo priceFrom={priceFrom} onView={onView} hasValidDepartures={hasValidDepartures} />
    </FooterWrapper>
  )
}
export default CruiseStickyFooter
